import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetLocation } from '../../../../state';

const FloorEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetLocation({ floor: event.target.value }));
  };

  return (
    <TextField
      label="Floor"
      size="small"
      fullWidth
      value={currentAsset?.floor || ''}
      onChange={handleChange}
    />
  );
};

export default FloorEdit;
